/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * How one answer ended.
 */
export type CardOutcome = {
  id: string;
  outcome: CardOutcome.outcome;
  status: string;
  message?: string | null;
};

export namespace CardOutcome {
  export enum outcome {
    DONE = "done",
    SCHEDULED = "scheduled",
    SKIPPED = "skipped",
    FAILED = "failed",
    TAKEN = "taken",
  }
}
